import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Carousel from './Carousel';
import Carlsbad from './assets/Carlsbad.jpg';
import Football from './assets/Football.jpg';
import Hackcon from './assets/Hackcon.jpg';
import Mexico from './assets/Mexico.jpg';
import Cave from './assets/Cave.jpg';
import NASA from './assets/NASA.jpg';
import SanFrancisco from './assets/SanFrancisco.jpg';
import Yosemite from './assets/Yosemite.jpg';
import Austin from './assets/Austin.jpg';

function Adventures() {
  const pictures = [
    { src: Hackcon, caption: 'I got invited to go to MLH Hackcon! It was an amazing experience in the middle of New York and I met some amazing fellow hackathon organizers.' },
    { src: SanFrancisco, caption: 'I went to San Francisco and explored the Bay Area. I enjoyed the weather and the food.' },
    { src: Austin, caption: 'I interned in Austin and got to try lots of cool restaurants. My favorites are Nori and Titaya\'s.' },
    { src: Yosemite, caption: 'I got to travel to Yosemite and Grand Teton National Parks and saw some amazing wildlife.' },
    { src: Football, caption: 'Nothing beats football season in College Station. We won this game against New Mexico State.' },
    { src: Mexico, caption: 'My study abroad trip to Mexico was amazing. I tried so much amazing food and got better at my Spanish.' },
    { src: Carlsbad, caption: 'I got to go Carlsbad Caverns and was fascinated by the caves.' },
    { src: NASA, caption: 'I got to pitch as a finalist for NASA Space2Pitch and explore the NASA Johnson Space Center.' },
    { src: Cave, caption: 'I traveled to a cave in Austin and spelunked through some tight spaces.' },
  ];

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Navbar />
      <main className="flex-grow text-white flex flex-col items-center pt-20 pb-20 px-0">
        <h1 className="text-xl mb-8">Photos</h1>
        <div className="w-full">
          <Carousel items={pictures} />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Adventures;
